import {ProgramDto} from '../dto/program.dto';
import {Program} from '../model/program';

export function convertProgramDtoToModel(dto: ProgramDto): Program {
  return {
    ...dto,
    id: dto._id,
  };
}
